import { SetMaskOnOff } from "src/Basic/SDOExtension";
import { getGlobalServerConfig } from "src/Route/RootMiddleware";
import { Download } from "src/Basic/Download";

const APIUrl = getGlobalServerConfig().backEndUrl.get();

const importMultiPDF = async (files) => {
    const url = APIUrl + "MergePDF/MergePDF";
    let form = new FormData();
    files.forEach(file => {
        form.append("importFiles", file.getRawFile());
    })
    await Download(url, "POST", form, new Headers(), true);
}

export default {
    importMultiPDF
}